"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
const immer_1 = __importDefault(require("immer"));
const typesafe_actions_1 = require("typesafe-actions");
const types_1 = require("../loading/types");
const actionCreators = __importStar(require("./actions"));
const initialQuote = {
    projectName: { value: '', error: null },
    firstName: { value: '', error: null },
    lastName: { value: '', error: null },
    companyName: { value: '', error: null },
    email: { value: '', error: null },
    phoneNumber: { value: '', error: null },
    isDistributor: { value: false, error: null },
    distributorId: { value: null, error: null },
    addressLine: { value: '', error: null },
    addressLine2: { value: '', error: null },
    city: { value: '', error: null },
    state: { value: '', error: null },
    zip: { value: '', error: null },
    countryId: { value: null, error: null },
    comment: { value: '', error: null },
};
const initialState = {
    form: initialQuote,
    submitStatus: types_1.LOADING_STATE.COMPLETE,
    disabled: false,
};
// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => (0, immer_1.default)(state, (draft) => {
    switch (action.type) {
        case (0, typesafe_actions_1.getType)(actionCreators.resetQuote): {
            draft.form = initialState.form;
            draft.submitStatus = initialState.submitStatus;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.updateQuoteValue): {
            draft.form[action.payload.key].value = action.payload.value;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.updateQuoteError): {
            draft.form[action.payload.key].error = action.payload.error;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.submitQuote): {
            draft.submitStatus = types_1.LOADING_STATE.LOADING;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.submitQuoteSuccess): {
            draft.submitStatus = types_1.LOADING_STATE.COMPLETE;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setEnabled): {
            draft.disabled = false;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setDisabled): {
            draft.disabled = true;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.submitQuoteError): {
            draft.submitStatus = types_1.LOADING_STATE.FAILED;
            action.payload.error.forEach(({ key, error }) => {
                draft.form[key].error = error;
            });
            // eslint-disable-next-line no-useless-return
            return;
        }
        default: {
            // eslint-disable-next-line no-useless-return
            return;
        }
    }
});
exports.default = reducer;
